import React, { createContext, useContext, useReducer } from "react";

export const TemplatesContext = createContext(null);
export const StateProvider = ({ reducer, initialState, children }) => (
  <TemplatesContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </TemplatesContext.Provider>
);
export const useTemplatesValue = () => useContext(TemplatesContext);
